class MobileMenuButton {
  constructor() {
    this.body = document.body;
    this.button = document.querySelector(
      "#mainMenu-trigger a, #mainMenu-trigger button",
    );
    this.processing = false;
    this.mainMenu = document.querySelector("#mainMenu");
    this.menuItemLinks = document.querySelectorAll(
      '#mainMenu nav > ul > li.dropdown > a[href="#"], #mainMenu nav > ul > li.dropdown > .dropdown-arrow, .dropdown-submenu > a[href="#"], .dropdown-submenu > .dropdown-arrow, .dropdown-submenu > span, .page-menu nav > ul > li.dropdown > a',
    );
  }

  init() {
    this.button.addEventListener("click", this.toggle.bind(this));

    this.menuItemLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        const parentLi = link.parentNode;
        const siblingLis = parentLi.parentNode.querySelectorAll("li.dropdown");
        const otherLis = Array.from(siblingLis).filter(
          (li) => li !== event.target.closest("li.dropdown"),
        );

        otherLis.forEach((siblingLi) => {
          siblingLi.classList.remove("hover-active");
        });

        if (this.body.classList.contains("b--responsive")) {
          parentLi.classList.toggle("hover-active");
        }

        event.stopPropagation();
        event.preventDefault();
      });
    });
  }

  menuItemsOpen() {}

  toggle() {
    this.processing = true;
    this.button.classList.toggle("toggle-active");
    this.body.classList.toggle("mainMenu-open");
    this.mainMenu.classList.toggle("menu-animate");
    if (this.mainMenu.classList.contains("menu-animate")) {
      this.mainMenu.style.minHeight = window.innerHeight + "px";
    } else {
      this.mainMenu.style.minHeight = "unset";
    }
  }
}

export default MobileMenuButton;
